import {Observable} from 'rx';
import Rx from 'rlink-rx';
import areEmbeddedValues from 'rlink-data-connector/areEmbeddedValues';
import areStoreSetActions from 'rlink-data-connector/areStoreSetActions';

// @TODO: Make splitBy useful again and use it.
function combineValueStreamWith (target, request, args) {
  let [targetValuesStream, targetActionsStream]
      = Rx.Observable.prototype.splitBy.call(target,
                                             [areEmbeddedValues, areStoreSetActions]);

  return function (origin) {
    let [originValuesStream, originActionsStream]
        = Rx.Observable.prototype.splitBy.call(origin, [
          areEmbeddedValues,
          areStoreSetActions,
        ]);

    return Rx.Observable.merge(
      targetValuesStream.combineLatest(originValuesStream)
        .map(([coll1, coll2]) => [...coll1, ...coll2]),
      targetActionsStream.merge(originActionsStream)
    );
  };
}

export default function addDependentRequests (initiatingRequestStream, initiatingRequest, ...requestArgsThenStreams) {
  let splitAt = requestArgsThenStreams.findIndex(r => r instanceof Observable);
  let requestArgs = requestArgsThenStreams.slice(0, splitAt);
  let requestStreams = requestArgsThenStreams.slice(splitAt);
  requestStreams = requestStreams.filter(stream => stream !== null);
  let mappedStreams = requestStreams.map(combineValueStreamWith(initiatingRequestStream, initiatingRequest, requestArgs));

  return Rx.Observable.merge(mappedStreams);
}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/streams/addDependentRequests.js